import { createContext as D, useContext as F, useState as M, useRef as j, useEffect as C, useCallback as U } from "react";
import { g as _, b as G } from "./i18nInstance-f01879af.js";
const K = (e, t, n, a) => {
  var s, c, N, l;
  const o = [n, {
    code: t,
    ...a || {}
  }];
  if ((c = (s = e == null ? void 0 : e.services) == null ? void 0 : s.logger) != null && c.forward)
    return e.services.logger.forward(o, "warn", "react-i18next::", !0);
  p(o[0]) && (o[0] = `react-i18next:: ${o[0]}`), (l = (N = e == null ? void 0 : e.services) == null ? void 0 : N.logger) != null && l.warn ? e.services.logger.warn(...o) : console != null && console.warn && console.warn(...o);
}, A = {}, S = (e, t, n, a) => {
  p(n) && A[n] || (p(n) && (A[n] = /* @__PURE__ */ new Date()), K(e, t, n, a));
}, k = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const n = () => {
      setTimeout(() => {
        e.off("initialized", n);
      }, 0), t();
    };
    e.on("initialized", n);
  }
}, b = (e, t, n) => {
  e.loadNamespaces(t, k(e, n));
}, P = (e, t, n, a) => {
  if (p(n) && (n = [n]), e.options.preload && e.options.preload.indexOf(t) > -1)
    return b(e, n, a);
  n.forEach((o) => {
    e.options.ns.indexOf(o) < 0 && e.options.ns.push(o);
  }), e.loadLanguages(t, k(e, a));
}, V = (e, t, n = {}) => !t.languages || !t.languages.length ? (S(t, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: t.languages
}), !0) : t.hasLoadedNamespace(e, {
  lng: n.lng,
  precheck: (a, o) => {
    var s;
    if (((s = n.bindI18n) == null ? void 0 : s.indexOf("languageChanging")) > -1 && a.services.backendConnector.backend && a.isLanguageChangingTo && !o(a.isLanguageChangingTo, e))
      return !1;
  }
}), p = (e) => typeof e == "string", J = (e) => typeof e == "object" && e !== null, W = D();
class X {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((n) => {
      this.usedNamespaces[n] || (this.usedNamespaces[n] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const Y = (e, t) => {
  const n = j();
  return C(() => {
    n.current = t ? n.current : e;
  }, [e, t]), n.current;
}, v = (e, t, n, a) => e.getFixedT(t, n, a), q = (e, t, n, a) => U(v(e, t, n, a), [e, t, n, a]), B = (e, t = {}) => {
  var L, O, z, R;
  const {
    i18n: n
  } = t, {
    i18n: a,
    defaultNS: o
  } = F(W) || {}, s = n || a || G();
  if (s && !s.reportNamespaces && (s.reportNamespaces = new X()), !s) {
    S(s, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const i = (d, g) => p(g) ? g : J(g) && p(g.defaultValue) ? g.defaultValue : Array.isArray(d) ? d[d.length - 1] : d, f = [i, {}, !1];
    return f.t = i, f.i18n = {}, f.ready = !1, f;
  }
  (L = s.options.react) != null && L.wait && S(s, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const c = {
    ..._(),
    ...s.options.react,
    ...t
  }, {
    useSuspense: N,
    keyPrefix: l
  } = c;
  let r = e || o || ((O = s.options) == null ? void 0 : O.defaultNS);
  r = p(r) ? [r] : r || ["translation"], (R = (z = s.reportNamespaces).addUsedNamespaces) == null || R.call(z, r);
  const u = (s.isInitialized || s.initializedStoreOnce) && r.every((i) => V(i, s, c)), T = q(s, t.lng || null, c.nsMode === "fallback" ? r : r[0], l), E = () => T, x = () => v(s, t.lng || null, c.nsMode === "fallback" ? r : r[0], l), [$, h] = M(E);
  let w = r.join();
  t.lng && (w = `${t.lng}${w}`);
  const I = Y(w), m = j(!0);
  C(() => {
    const {
      bindI18n: i,
      bindI18nStore: f
    } = c;
    m.current = !0, !u && !N && (t.lng ? P(s, t.lng, r, () => {
      m.current && h(x);
    }) : b(s, r, () => {
      m.current && h(x);
    })), u && I && I !== w && m.current && h(x);
    const d = () => {
      m.current && h(x);
    };
    return i && (s == null || s.on(i, d)), f && (s == null || s.store.on(f, d)), () => {
      m.current = !1, s && (i == null || i.split(" ").forEach((g) => s.off(g, d))), f && s && f.split(" ").forEach((g) => s.store.off(g, d));
    };
  }, [s, w]), C(() => {
    m.current && u && h(E);
  }, [s, l, u]);
  const y = [$, s, u];
  if (y.t = $, y.i18n = s, y.ready = u, u || !u && !N)
    return y;
  throw new Promise((i) => {
    t.lng ? P(s, t.lng, r, () => i()) : b(s, r, () => i());
  });
}, Z = (e) => {
  const { t, ...n } = B();
  return {
    /**
     *
     * @param defaultLabel - default label to be used if nothing is provided. By default it's in English
     * @param defaultKey - default key to be used, it follows the componentName.defaultKey pattern where defaultKey is the prop name e.g. labelProp.label, placeholder, etc.
     * @param value - value to be translated, it's the actual user-provided value. If a translation is available, it will be used; otherwise, the same value will be returned.
     * @returns translated value
     */
    t: (a, o, s) => {
      const c = s ? `${e}.${s}` : "", N = `${e}.${a}`, l = o ? `${e}.${o}` : "", r = t(c), u = t(N), T = t(l);
      return r !== c ? r : s ? t(s) : u !== N ? u : T !== l ? T : t(a);
    },
    ...n
  };
};
export {
  Z as useCustomTranslation
};
